import React, { useEffect, useState } from 'react';
import {Box, Container, makeStyles} from '@material-ui/core';
import Page from 'src/components/Page';
import Results from './Results';
import Toolbar from './Toolbar'; 
import { WorkerDemanderService } from 'src/services';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const WorkRequestList = () => {
  const { id } = useParams(); 
  const classes = useStyles();
  const [requestLists, setRequestLists] = useState([]);

  useEffect(function effectFunction(){
    WorkerDemanderService.GET_UNPLANNED_WORK_REQUESTS(id)
    .then(({data}) =>{  
      setRequestLists(data.data);         
    })
    .catch((error) => {
      console.log("Work Requests List getting failed.");
      console.error(error);
    }); 
  }, []);    


  return (
    <Page className={classes.root} title="Work List">
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
          <Results workrequstlists={requestLists} />
        </Box>
      </Container>
    </Page>
  );
};

export default WorkRequestList;
